module.exports = __webpack_public_path__ + "img/image141.32befece.jpg";